import React, { useCallback, useEffect, useState } from 'react';
import {useHistory, useLocation, useParams} from 'react-router-dom';

import Heading from '../../components/stateless/Heading';
import PageTitle from '../../components/stateless/PageTitle';

import {
  Menu,
  ToolsMenu,
  ToolsList,
  PaymentsList,
  PaymentsMenu,
  ProductsList,
  ServicesMenu,
  ProductsMenu,
  SERVICES_MENU,
  KnowledgeList,
  SolutionsList,
} from '../../constants';

import './index.scss';

function ItemSinglePage() {
  const history = useHistory();
  const { category, categoryItem } = useParams();
  const {pathname} = useLocation();

  const showButton = pathname.includes('business-development') || pathname.includes('law') || pathname.includes('sports-and-gaming') || pathname.includes('other')


  const solutionId = window.location.hash.split('#')[1];

  const [solutionSlug, setSolutionSlug] = useState(solutionId || '');
  const [solutionSlugClick, setSolutionSlugClick] = useState(null);
  const [sections, setSections] = useState([]);

  let menu, list;

  switch (category) {
    case 'products':
      menu = ProductsMenu;
      list = ProductsList;
      break;
    case 'payments':
      menu = PaymentsMenu;
      list = PaymentsList;
      break;
    case 'tools':
      menu = ToolsMenu;
      list = ToolsList;
      break;
    case 'business-operations':
      menu = Menu;
      list = KnowledgeList;
      break;
    case 'content-management':
      menu = Menu;
      list = KnowledgeList;
      break;
    case 'products-and-solutions':
      menu = Menu;
      list = KnowledgeList;
      break;
    case 'business-development':
      menu = SERVICES_MENU;
      list = ServicesMenu;
      break;
    case 'sports-and-gaming':
      menu = SERVICES_MENU;
      list = ServicesMenu;
      break;
    case 'other':
      menu = SERVICES_MENU;
      list = ServicesMenu;
      break;
    case 'law':
      menu = SERVICES_MENU;
      list = ServicesMenu;
      break;
    default:
      menu = [];
      list = [];
      break;
  }

  const item = list.find(item => item.path.split('/')[1] === categoryItem);

  if (!item) {
    history.push(`/not-found`);
  }

  const markup = (str) => ({ __html: str });

  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: 'smooth'
    });
  }, []);

  useEffect(() => {
    setSections(document.querySelectorAll('section.section-anchor'));
  }, []);

  const handleSideClick = (item) => {
    setSolutionSlug(item.slug);
    setSolutionSlugClick(item.slug);
    setTimeout(() => setSolutionSlugClick(null), 0);
  }

  const handleScroll = useCallback((e) => {
    let scrollY = window.pageYOffset;
    const inBottomPage = (window.innerHeight + window.scrollY) >= document.body.offsetHeight

    sections.forEach(current => {
      const sectionHeight = current.offsetHeight;
      const sectionTop = current.offsetTop - 100;
      const sectionId = solutionSlugClick || current.getAttribute("id");

      if (
        scrollY > sectionTop &&
        scrollY <= (sectionTop + sectionHeight)
      ) {
        setSolutionSlug(sectionId);
      }
      if (inBottomPage) {
        setSolutionSlug(sections[sections.length-1].id)
      }
      if (scrollY === 0) {
        setSolutionSlug(SolutionsList[0].slug)
      }
    })
  }, [sections, solutionSlugClick]);

  window.addEventListener('scroll', handleScroll);

  return (
    item ? <>
      <PageTitle heading={item.name} icon={item.icon} description={item.shortDescription}/>
      <div className="solutions-content-wrapper">
        <div className="container-layout">
          <div className="solutions-container">
            {menu.length ? <nav className="solutions-content-menu">
              {
                menu.map(item =>
                  (item.slug === 'releaseNotes' && categoryItem === 'odds-feed') || (item.slug === 'setup' && categoryItem === 'friendship')
                    ? null :
                  <a href={`#${item.slug}`} className="solutions-content-menu-inner" key={item.slug}
                     onClick={() => handleSideClick(item)}>
                    <label htmlFor={item.slug + 'contentMenuITem'}
                           className={item.slug === solutionSlug ? 'text-selected' : ''}>{item.name}</label>
                  </a>
                )
              }
            </nav> : null}
            <div className="content-item sing">
              {
                menu.length ? menu.map(menuItem => (
                  (menuItem.slug === 'releaseNotes' && categoryItem === 'odds-feed') || (menuItem.slug === 'setup' && categoryItem === 'friendship')
                    ? null :
                    <section id={menuItem.slug} className="section-anchor">
                      <p className="sing-title">{menuItem.name}</p>
                      <div className="strong-a" dangerouslySetInnerHTML={markup(item[menuItem.slug])}/>
                    </section>
                  )
                ) : <div dangerouslySetInnerHTML={markup(item.description)}/>
              }
              {showButton && (
                  <div className="page-title-button">
                    <button className="filled green" type="button" onClick={() => history.push("/request-demo")}>
                      Request Demo
                    </button>
                  </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </> : null
  );
}

export default ItemSinglePage;
